<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      class="flex-1 overflow-y-auto p-2.5"
    >
      <el-form-item label="状态" v-if="props.id">
        <el-switch
          v-model="state.model.status"
          active-text="启用"
          inactive-text="禁用"
          inline-prompt
          :active-value="1"
          :inactive-value="0"
        />
      </el-form-item>
      <el-form-item label="上级部门">
        <el-tree-select
          v-model="state.model.pid"
          :data="state.treeData"
          node-key="id"
          :props="{
            children: 'children',
            label: 'name',
          }"
          default-expand-all
          check-strictly
          clearable
        >
          <template #footer>
            <el-button
              plain
              class="float-right mb-3"
              size="small"
              @click="onLoadTree"
            >
              刷新
            </el-button>
          </template>
        </el-tree-select>
      </el-form-item>
      <el-form-item
        label="部门名称"
        prop="name"
        :rules="[
          { required: true, message: '请输入部门名称', trigger: 'blur' },
        ]"
      >
        <el-input v-model="state.model.name"></el-input>
      </el-form-item>
      <el-form-item label="简称">
        <el-input v-model="state.model.short_name"></el-input>
      </el-form-item>
      <el-form-item label="序号">
        <template #label>
          <div class="flex gap-x-1 items-center">
            <text>序号</text>
            <el-tooltip effect="dark" content="序号越大，显示越靠前">
              <el-icon class="cursor-pointer">
                <QuestionFilled />
              </el-icon>
            </el-tooltip>
          </div>
        </template>
        <el-input v-model="state.model.sort"></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box">
      <el-button type="primary" size="large" class="w-full" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { data_getDepartment_tree } from "@/http/data";
import {
  department_detail,
  department_add,
  department_edit,
} from "@/http/department";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
    pid: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
      },
    });
    onMounted(() => {
      onLoadTree();
      if (props.pid) state.model.pid = props.pid;
      if (props.id) {
        department_detail(props.id).then((res) => {
          if (res.status == 200) state.model = res.data?.data;
        });
      }
    });

    const onLoadTree = () => {
      data_getDepartment_tree().then((res) => {
        if (res.status == 200) state.treeData = res.data?.data || [];
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            department_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            department_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      onLoadTree,
    };
  },
};
</script>
<style scoped></style>
